import React from 'react';

import {
  Flex, Stack, Text, Wrap,
} from '@chakra-ui/react';

import { StatusBadge } from 'components';
import { Images } from 'containers/Table/Item/Images';
import { InfoRow } from 'containers/Texts';

function GrayInfoRow({ label, value }) {
  return (
    <>
      {value ? (
        <InfoRow
          labelColor="gray.500"
          valueColor="gray.500"
          valueVariant="2xSmallRegular"
          labelVariant="2xSmallSemiBold"
          label={label}
          value={value}
        />
      ) : null}
    </>
  );
}

export default function InfoSection({
  name,
  barCode,
  type,
  amount,
  temperature,
  container,
  packaging,
  patients,
  status,
  value = [],
}) {
  return (
    <Flex
      position="relative"
      borderRadius="8px"
      py={3}
      pr={3}
      alignItems="center"
      pl={4}
      borderColor="gray.200"
      mt={1}
      borderWidth="1px">
      <Stack alignSelf="flex-start">
        <StatusBadge
          minW={4}
          status={status}
        />
        <Text
          variant="mediumBold"
          color="primary.default">{name}
        </Text>
      </Stack>
      <Wrap
        spacing={3}
        px={4}
        maxW="70%"
        justifyContent="space-between">
        <Flex
          hidden={!barCode}
          flexDir="column">
          <Text
            color="gray.500"
            variant="2xSmallRegular">
            {barCode}
          </Text>
        </Flex>
        <Flex flexDir="column">
          <GrayInfoRow
            label="Quantidade:"
            value={amount}
          />
          <GrayInfoRow
            label="Pacientes:"
            value={patients}
          />
        </Flex>
        <Flex flexDir="column">
          <GrayInfoRow
            label="Temperatura:"
            value={`${temperature}°`}
          />
          <GrayInfoRow
            label="Acondiciona.:"
            value={packaging}
          />
        </Flex>
        <Flex flexDir="column">
          <GrayInfoRow
            label="Embalagem:"
            value={container}
          />
          <GrayInfoRow
            label="Tipo:"
            value={type}
          />
        </Flex>
      </Wrap>
      <Images
        position="absolute"
        right={4}
        value={value}
      />
    </Flex>
  );
}
